import { FloatingFormItem } from '@/components/_common';
import { useGroups } from '@/core/domain/operational/Groups/Groups.hooks';
import {
  ReportInventoryFilterByEnum,
  ReportInventoryFormValues,
  ReportInventoryOrderByEnum,
} from '@/core/domain/reports/stock/Report.types';
import {
  Button,
  Col,
  Divider,
  Form,
  FormInstance,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Typography,
} from 'antd';

interface InventoryReportModalFormInterface {
  form: FormInstance<ReportInventoryFormValues>;
}

export default function InventoryReportModalForm({
  form,
}: InventoryReportModalFormInterface) {
  const {
    data: groupData,
    isFetching: groupFetching,
    hasNextPage: groupHasNextPage,
    fetchNextPage: groupFetchNext,
  } = useGroups();

  const groupMapOptions = groupData
    ? groupData.pages[0].data.map((cur) => ({ value: cur.id, label: cur.name }))
    : [];

  const filterByOptions = [
    { value: ReportInventoryFilterByEnum.AllItems, label: 'Todos os Itens' },
    {
      value: ReportInventoryFilterByEnum.OnlyDifferentFromBefore,
      label: 'Somente itens com a quantidade contada diferente da anterior',
    },
    {
      value: ReportInventoryFilterByEnum.OnlySelected,
      label: 'Somente itens selecionados',
    },
  ];

  const orderByOptions = [
    {
      value: ReportInventoryOrderByEnum.ManufacturerCode,
      label: 'Código do fabricante',
    },
    { value: ReportInventoryOrderByEnum.Groups, label: 'Grupos' },
    { value: ReportInventoryOrderByEnum.Localization, label: 'Localização' },
  ];

  return (
    <Form form={form}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={16}>
          <Typography.Title level={4}>Filtrar por</Typography.Title>
          <Divider />
          <Form.Item
            noStyle
            name="filterBy"
            initialValue={ReportInventoryFilterByEnum.AllItems}
          >
            <Radio.Group options={filterByOptions} />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={8}>
          <Typography.Title level={4}>Ordenar por</Typography.Title>
          <Divider />
          <Form.Item
            noStyle
            name="orderBy"
            initialValue={ReportInventoryOrderByEnum.ManufacturerCode}
          >
            <Radio.Group>
              <Space direction="vertical">
                {orderByOptions.map(({ label, value }) => (
                  <Radio value={value}>{label}</Radio>
                ))}
              </Space>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={16}>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12}>
              <FloatingFormItem label="Código" name="codeStart">
                <Input />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <FloatingFormItem label="Até" name="codeEnd">
                <Input />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <FloatingFormItem label="Localização" name="localizationStart">
                <Input />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <FloatingFormItem label="Até" name="localizationEnd">
                <Input />
              </FloatingFormItem>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <FloatingFormItem label="Grupo" name="groupIds">
                <Select
                  style={{ width: '100%' }}
                  options={groupMapOptions}
                  disabled={groupFetching}
                  mode="multiple"
                  allowClear
                  dropdownRender={(children) => (
                    <>
                      {children}
                      {groupHasNextPage && (
                        <Button
                          block
                          type="link"
                          onClick={() => groupFetchNext()}
                        >
                          Carregar Mais
                        </Button>
                      )}
                    </>
                  )}
                />
              </FloatingFormItem>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
}
